module.exports = __webpack_public_path__ + "static/06.c4dbf219.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/gallery/06.png
// module id = 443
// module chunks = 35783957827783 172322841747965